let util = {};

/**
 * 判断当前目标数组中是否存在某个元素
 * @param ele   元素
 * @param targetArr 目标数组
 * @returns {boolean}
 */
util.oneOf = (ele, targetArr) => {
  if (targetArr.indexOf(ele) >= 0) {
    return true;
  } else {
    return false;
  }
};

/**
 * 显示当前路径
 * @param itAccess
 * @param currentAccess
 * @returns {boolean}
 */
util.showThisRoute = function (itAccess, currentAccess) {
  if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
    return util.oneOf(currentAccess, itAccess);
  } else {
    return itAccess === currentAccess;
  }
};

/**
 * 语言切换,但我们其实不需要
 * @param vm
 * @param item
 * @returns {*}
 */
util.handleTitle = function (vm, item) {
  if (typeof item.title === 'object') {
    return item.title.i18n;
  } else {
    return item.title;
  }
};

/**
 * 通过名称获取对应路由
 * @param routers
 * @param name
 * @returns {*}
 */
util.getRouterObjByName = function (routers, name) {
  if (!name || !routers || !routers.length) {
    return null;
  }
  // debugger;
  let routerObj = null;
  for (let item of routers) {
    if (item.name === name) {
      return item;
    }
    routerObj = util.getRouterObjByName(item.children, name);
    if (routerObj) {
      return routerObj;
    }
  }
  return null;
};

/**
 * 设置当前面包屑路径
 * @param vm
 * @param name
 * @returns {*[]}
 */
util.setCurrentPath = function (vm, name,flag) {
  let title = '';
  let isOtherRouter = false;
  vm.$store.state.app.routers.forEach(item => {
    if (item.children.length === 1) {
      if (item.children[0].name === name) {
        title = util.handleTitle(vm, item);
        if (item.name === 'otherRouter') {
          isOtherRouter = true;
        }
      }
    } else {
      item.children.forEach(child => {
        if (child.name === name) {
          title = util.handleTitle(vm, child);
          if (item.name === 'otherRouter') {
            isOtherRouter = true;
          }
        }
      });
    }
  });
  let currentPathArr = [];
  if (name === 'home_index') {
    currentPathArr = [
      {
        title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
        path: '',
        name: 'home_index'
      }
    ];
  } else if ((name.indexOf('_index') >= 0 || isOtherRouter) && name !== 'home_index') {
    currentPathArr = [
      {
        title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
        path: '/user-center/home',
        name: 'home_index'
      },
      {
        title: title,
        path: '',
        name: name
      }
    ];
  } else {
    let currentPathObj = vm.$store.state.app.routers.filter(item => {
      if (item.children.length <= 1) {
        return item.children[0].name === name;
      } else {
        let i = 0;
        let childArr = item.children;
        let len = childArr.length;
        while (i < len) {
          if (childArr[i].name === name) {
            return true;
          }
          i++;
        }
        return false;
      }
    })[0];
    if (currentPathObj.children.length < 1 && currentPathObj.name === 'home') {
      currentPathArr = [
        {
          title: '首页',
          path: '',
          name: 'home_index'
        }
      ];
    } else if (currentPathObj.children.length < 1 && currentPathObj.name !== 'home') {
      currentPathArr = [
        {
          title: '首页',
          path: '/user-center/home',
          name: 'home_index'
        },
        {
          title: currentPathObj.title,
          path: '',
          name: name
        }
      ];
    } else {
      let childObj = currentPathObj.children.filter((child) => {
        return child.name === name;
      })[0];
      currentPathArr = [
        {
          title: '首页',
          path: '/user-center/home',
          name: 'home_index'
        },
        {
          title: currentPathObj.title,
          path: '',
          name: currentPathObj.name
        },
        {
          title: childObj.title,
          path: currentPathObj.path + '/' + childObj.path,
          name: name
        }
      ];
    }
  }


  if (flag) {
    currentPathArr[2] = flag[0];
    currentPathArr[3] = flag[1];
  }

  vm.$store.commit('setCurrentPath', currentPathArr);
  return currentPathArr;
};

/**
 * 验证当前是否登录
 * @param vm
 * @param access
 * @returns {boolean}
 */
util.isLogin = function (vm, access) {
  if (access != undefined) {
    return true;
  } else {
    vm.$router.push({
      name: 'login'
    });
    return false;
    // return true;
  }
};

/**
 * 打开一个新页面 -> tab面板
 * @param vm
 * @param name
 * @param argu
 * @param query
 */
util.openNewPage = function (vm, name, argu, query) {
  let pageOpenedList = vm.$store.state.app.pageOpenedList;
  let openedPageLen = pageOpenedList.length;
  let i = 0;
  let tagHasOpened = false;
  while (i < openedPageLen) {
    if (name === pageOpenedList[i].name) { // 页面已经打开
      vm.$store.commit('pageOpenedList', {
        index: i,
        argu: argu,
        query: query
      });
      tagHasOpened = true;
      break;
    }
    i++;
  }
  if (!tagHasOpened) {
    let tag = vm.$store.state.app.tagsList.filter((item) => {
      if (item.children) {
        return name === item.children[0].name;
      } else {
        return name === item.name;
      }
    });

    tag = tag[0];
    if (tag) {
      tag = tag.children ? tag.children[0] : tag;
      if (argu) {
        tag.argu = argu;
      }
      if (query) {
        tag.query = query;
      }
      vm.$store.commit('increateTag', tag);
    }
  }
  vm.$store.commit('setCurrentPageName', name);
};


// 验证手机号
util.validPhone = (phone) => {
  let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
  if (!myreg.test(phone)) {
    return false;
  } else {
    return true;
  }
};


/**
 * 替换键值
 * @param obj
 * @param key1
 * @param key2
 */
util.replaceObjKey = (obj,key1,key2) => {
  return obj.map(val => {
    return {
      'name': val[key1],
      'id': val[key2]
    }
  });
};

util.convertTree = function (tree, map) {
  const result = []

  // 遍历 tree
  tree.forEach((item) => {
    // 解构赋值
    let {
      name: value,
      name: label,
      children: children
    } = item

    // 如果有子节点，递归
    if (children) {
      children = util.convertTree(children)

      result.push({
        value,
        label,
        children
      })

    }else {
      result.push({
        value,
        label
      })
    }


  })

  return result
}


/**
 * 度分秒转换成为度
 * @param value 度(小数)
 * @returns {string}
 * @constructor
 */
util.DegreeConvertBack = (value) => {
  // 通用的度分秒
  /*let du = value.split("°")[0];
  let fen = value.split("°")[1].split("'")[0];
  let miao = value.split("°")[1].split("'")[1].split('"')[0];*/

  // 项目中奇葩的度分秒
  let du = value.split(".")[0];
  let fen = value.split(".")[1];
  let miao = value.split(".")[2];

  return Math.abs(du) + (Math.abs(fen)/60 + Math.abs(miao)/3600);
}


export const excelFormat = (key, jsonData) => {
  return jsonData.map(v => key.map(j => {
    if (j == 'address') {
      return `${v.country}${v.province}${v.city}${v.district}${v.street}${v.detail}`
    }else if (j == 'state') {
      switch (v[j]) {
        case 1:
          return '未审核';
        case 2:
          return '审核已通过';
        case 3:
          return '审核未通过';
        default:
          break;
      }
    }else if (j == 'type') {
      switch (v[j]) {
        case 0:
          return '小区';
        case 1:
          return '普通';
        default:
          break;
      }
    }else if (j == 'partner') {
      return `${v.partnerName}(${v.partnerPhone})`
    }else if (j == 'admin') {
      return `${v.adminName}(${v.adminPhone})`
    }else if (j == 'gmtCreate') {
      return new Date(v[j]).Format("yyyy-MM-dd hh:mm:ss");
    }else {
      return v[j]
    }
  }))
};

//使用递归的方式实现数组、对象的深拷贝
export const deepClone = (obj) => {
  //判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
  var objClone = Array.isArray(obj) ? [] : {};
  //进行深拷贝的不能为空，并且是对象或者是
  if (obj && typeof obj === "object") {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] && typeof obj[key] === "object") {
          objClone[key] = deepClone(obj[key]);
        } else {
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
}

/**
 * 将对象所有字段置为空
 */


export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js